import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import RestaurantBG from "../../helper/images/Restaurantorder.png";
import { FaMapMarkerAlt, FaSearch } from "react-icons/fa";
import { IoLocationOutline } from "react-icons/io5";
import { CiSearch } from "react-icons/ci";
import Rest1 from "../../helper/images/rest1.png";
import Rest2 from "../../helper/images/rest2.png";
import Rest3 from "../../helper/images/rest3.png";
import "../../App.css";
import { LiaAngleLeftSolid, LiaAngleRightSolid } from "react-icons/lia";
import { Link, useNavigate } from "react-router-dom";
import { FaSliders } from "react-icons/fa6";
import { getLocations, getRestaurantsOrHotels } from "../../api/user";
import { useQuery } from "@tanstack/react-query";
import Location from "../Home/Location";
import { MdStar, MdStarHalf, MdStarOutline } from "react-icons/md";
import UserPagination from "../../components/common/UserPagination";
import { RiHotelLine } from "react-icons/ri";
import { useTranslation } from "../../hooks/useTranslation";
import { RestaurantGridLoading } from "../../helper/lorder";

const DEFAULT_FILTERS = {
  location: "",
  cuisineType: "",
  distance: "",
  minPrice: "",
  maxPrice: "",
  foodType: "",
  ratings: "",
  amenities: "",
};

const RestaurantOrdering = ({ currentPage = 1, totalPages = 99 }) => {
  const { t } = useTranslation();
  const pages = [1, 2, 3, "...", totalPages];
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const { data: locationsData } = useQuery({
    queryKey: ["locations", "restaurants"],
    queryFn: () => getLocations({ hotels: false, restaurants: true }),
    keepPreviousData: true,
  });
  const locations = locationsData?.data?.data || [];
  const [filters, setFilters] = useState(() => ({ ...DEFAULT_FILTERS }));
  const cuisineOptions = [
    { value: "Fast Food", label: t("restaurant").cuisineType.FastFood },
    { value: "Italian", label: t("restaurant").cuisineType.Italian },
    { value: "Indian", label: t("restaurant").cuisineType.Indian },
    { value: "Chinese", label: t("restaurant").cuisineType.Chinese },
    { value: "Mexican", label: t("restaurant").cuisineType.Mexican },
    { value: "Thai", label: t("restaurant").cuisineType.Thai },
    { value: "Japanese", label: t("restaurant").cuisineType.Japanese },
    { value: "French", label: t("restaurant").cuisineType.French },
    { value: "Greek", label: t("restaurant").cuisineType.Greek },
    { value: "Vegan", label: t("restaurant").cuisineType.Vegan },
    { value: "Seafood", label: t("restaurant").cuisineType.Seafood },
    { value: "BBQ", label: t("restaurant").cuisineType.BBQ },
  ];
  const [appliedFilters, setAppliedFilters] = useState(() => ({ ...DEFAULT_FILTERS }));
  const [userLocation, setUserLocation] = useState({
    latitude: null,
    longitude: null,
  });
  const [page, setPage] = useState(1);
  const limit = 6;

  // Keep location changes applied immediately to search (trim whitespace)
  const handleLocationChange = (e) => {
    const { value } = e.target;
    const trimmed = value.replace(/^\s+|\s+$/g, "");
    setFilters((prev) => ({ ...prev, location: trimmed }));
    setAppliedFilters((prev) => ({ ...prev, location: trimmed }));
  };

  const {
    data: searchedData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["hotels-restaurants", appliedFilters, userLocation, page, limit , debouncedQuery],
    queryFn: () =>
      getRestaurantsOrHotels({
        hotels: false,
        rating: appliedFilters.ratings,
        cuisineType: appliedFilters.cuisineType,
        address: (appliedFilters.location || "").trim(),
        features:
          appliedFilters.amenities === "All amenities"
            ? undefined
            : appliedFilters.amenities,
        min: appliedFilters.minPrice,
        max: appliedFilters.maxPrice,
        latitude: userLocation.latitude,
        longitude: userLocation.longitude,
        foodType: appliedFilters.foodType,
        distance: appliedFilters.distance,
        page,
        limit,
        search : (debouncedQuery || "").trim(),
      }),
    keepPreviousData: true,
  });

  const data = searchedData?.data?.data;
  const pagination = searchedData?.data?.pagination;

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          console.error(t("restaurant").search.error, error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  }, []);

  useEffect(() => {
  const handler = setTimeout(() => {
    setDebouncedQuery((query || "").trim());
  }, 500); // wait 500ms after user stops typing

  return () => {
    clearTimeout(handler);
  };
}, [query]);

  // ---------
  
  const [filtered, setFiltered] = useState([]);
  // const navigate = useNavigate();

  const handleSearch = (e) => {
    const value = e.target.value;
    setQuery(value);
  };

  const handleSelect = (item) => {
    navigate(`/restaurantdetail`, {
      state: { restaurantId: item?._id, reservationId: null },
    });
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    const updated = {
      ...filters,
      [name]: value,
    };

    setFilters(updated);
  };

  const handleClearFilters = () => {
    setFilters({ ...DEFAULT_FILTERS });
    setAppliedFilters({ ...DEFAULT_FILTERS });
    setQuery("");
    setDebouncedQuery("");
    setPage(1);
  };

  const applyFilters = (nextFilters = filters, options = { resetPage: true }) => {
    setFilters(nextFilters);
    setAppliedFilters(nextFilters);
    if (options.resetPage) setPage(1);
  };

  return (
    <>
      <div
        className="relative z-[1] object-cover bg-no-repeat lg:py-[166px] md:py-[100px] py-[70px]  before:w-full before:h-full before:absolute before:bg-[#000] before:opacity-[47%] before:z-[-1] before:top-0 before:left-0 before:right-0 before:bottom-0"
        style={{ backgroundImage: "url(" + RestaurantBG + ")" }}
      >
        <div className="relative w-full max-w-[1005px] mx-auto">
          <div className="bg-white rounded-[10px] shadow-md flex md:flex-row flex-col md:items-center py-[11px] px-[19px] md:gap-[31px] gap-2 md:h-[73px] relative z-10">
            {/* <div className="flex items-center gap-[10px] flex-1">
              <IoLocationOutline size={24} className="text-[#4CAF50]" />
              <input
                type="text"
                name="location"
                value={filters.location}
                onChange={handleLocationChange}
                placeholder={
                  t("restaurant")?.search?.addressPlaceholder ||
                  t("restaurant")?.search?.placeholder ||
                  "Search by address"
                }
                className="w-full outline-none placeholder-gray-500 text-gray-800"
              />
            </div> */}

            <div className=" md:w-px h-[1px] w-full bg-[#DDDDDD] md:h-full" />

            <div className="flex items-center flex-1 gap-[10px] relative">
              <CiSearch size={24} className="text-[#4CAF50]" />
              <input
                type="text"
                value={query}
                onChange={handleSearch}
                placeholder={t("restaurant").search.placeholder}
                className="w-full outline-none placeholder-gray-500 text-gray-800"
              />

              {Boolean(filters.location) && locations?.length > 0 && (
                <div className="absolute top-full left-0 mt-2 w-full bg-white border border-gray-200 rounded-md shadow-lg z-20 max-h-64 overflow-auto">
                  {locations
                    .filter((l) =>
                      (l?.city || "").toLowerCase().includes(filters.location.toLowerCase())
                    )
                    .slice(0, 8)
                    .map((l) => (
                      <button
                        key={`${l?.city}-${l?.country}-${l?.state}`}
                        type="button"
                        onClick={() => {
                          const selected = l?.city || "";
                          setFilters((prev) => ({ ...prev, location: selected }));
                          setAppliedFilters((prev) => ({ ...prev, location: selected }));
                        }}
                        className="w-full text-left px-4 py-2 hover:bg-gray-50"
                      >
                        {(l?.city || "").trim()} {(l?.state ? `, ${l.state}` : "")} {(l?.country ? `, ${l.country}` : "")}
                      </button>
                    ))}
                </div>
              )}
            </div>
          </div>

          {/* Search Results */}
          {filtered.length > 0 && (
            <div className="absolute top-full left-0 right-0 bg-white shadow-lg rounded-b-md z-20 max-h-[300px] overflow-auto mt-1">
              {filtered.map((item) => (
                <div
                  key={item._id}
                  onClick={() => handleSelect(item)}
                  className="flex gap-3 items-center p-3 cursor-pointer hover:bg-gray-100 border-b"
                >
                 
                  <img
                    src={item.images[0]}
                    alt={item.name}
                    className="w-14 h-14 object-cover rounded-md"
                  />
                  <div>
                    <h4 className="text-md font-semibold text-gray-800">
                      {item.name}
                    </h4>
                    <p className="text-sm text-gray-500">{item.address}</p>
                    <p className="text-sm text-[#4CAF50]">⭐ {item.rating}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="container">
        <div className="lg:pb-[100px] md:pb-[70px] pb-[30px] pt-[50px]">
          <div className="flex flex-wrap gap-5 items-center">
            <Link className="flex items-center gap-[9px] justify-end sm:text-xl text-sm font-medium">
              <FaSliders />
              {t("restaurant").search.filter}
            </Link>
            <select
              name="cuisineType"
              value={filters.cuisineType}
              onChange={handleFilterChange}
              className="border border-[#DDDDDD] px-[13px] py-[12px] text-sm focus:outline-none rounded-[5px] w-full max-w-[165px]"
            >
              <option value="">{t("restaurant").search.cuisineType}</option>
              {cuisineOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>

            <select
              name="minPrice"
              value={filters.minPrice}
              onChange={handleFilterChange}
              className="border border-[#DDDDDD] px-[13px] py-[12px] text-sm focus:outline-none rounded-[5px] w-full max-w-[165px]"
            >
              <option value="">{t("restaurant").search.minPrice}</option>
              <option value="100">100</option>
              <option value="200">200</option>
              <option value="300">300</option>
              <option value="400">400</option>
            </select>

            <select
              name="maxPrice"
              value={filters.maxPrice}
              onChange={handleFilterChange}
              className="border border-[#DDDDDD] px-[13px] py-[12px] text-sm focus:outline-none rounded-[5px] w-full max-w-[165px]"
            >
              <option value="">{t("restaurant").search.maxPrice}</option>
              <option value="200">200</option>
              <option value="300">300</option>
              <option value="400">400</option>
              <option value="500">500</option>
            </select>

            <select
              name="foodType"
              value={filters.foodType}
              onChange={handleFilterChange}
              className="border border-[#DDDDDD] px-[13px] py-[12px] text-sm focus:outline-none rounded-[5px] w-full max-w-[175px]"
            >
              <option value="">{t("restaurant").search.foodType}</option>
              <option value="veg">{t("restaurant").foodTypes.veg}</option>
              <option value="non-veg">
                {t("restaurant").foodTypes.nonVeg}
              </option>
              <option value="both">{t("restaurant").foodTypes.both}</option>
            </select>

            <select
              name="ratings"
              value={filters.ratings}
              onChange={handleFilterChange}
              className="border border-[#DDDDDD] px-[13px] py-[12px] text-sm focus:outline-none rounded-[5px] w-full max-w-[125px]"
            >
              <option value="">{t("home").searchFilter.ratingAny}</option>
              <option value="1">{t("restaurant").ratings.one}</option>
              <option value="2">{t("restaurant").ratings.two}</option>
              <option value="3">{t("restaurant").ratings.three}</option>
              <option value="4">{t("restaurant").ratings.four}</option>
              <option value="5">{t("restaurant").ratings.five}</option>
            </select>

            <select
              name="distance"
              value={filters.distance}
              onChange={handleFilterChange}
              className="border border-[#DDDDDD] px-[13px] py-[12px] text-sm focus:outline-none rounded-[5px] w-full max-w-[129px]"
            >
              <option value="">{t("restaurant").search.distance}</option>
              <option value="1">{t("restaurant").distanceOptions.one}</option>
              <option value="5">{t("restaurant").distanceOptions.two}</option>
              <option value="10">
                {t("restaurant").distanceOptions.three}
              </option>
              <option value="20">{t("restaurant").distanceOptions.four}</option>
              <option value="50">{t("restaurant").distanceOptions.five}</option>
            </select>

            <button
              onClick={() => {
                setAppliedFilters(filters);
                setPage(1); // reset to first page
              }}
              className="md:max-w-[102px] w-full rounded-[2px] bg-[#4CAF50] 2xl:text-lg text-base text-white text-center font-bold 2xl:py-[8px] 2xl:px-[20px] p-3 green-shadow hover:bg-[#209b25]"
            >
              {t("restaurant").search.searchBtn}
            </button>
          </div>

{isLoading?<div className="mt-[37px]">
  <RestaurantGridLoading/>
</div>:<div
            className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-[21px] items-start pt-[37px] w-full"
          >
            {isLoading ? (
              <RestaurantGridLoading/>
            ) : isError ? (
              <p className="text-red-500 text-center mt-6">{error.message}</p>
            ) : data?.length > 0 ? (
              // Apply frontend distance filter and compute distance
              (() => {
                const toRad = (value) => (value * Math.PI) / 180;
                const haversineKm = (lat1, lon1, lat2, lon2) => {
                  if ([lat1, lon1, lat2, lon2].some((v) => v == null || isNaN(v))) return null;
                  const R = 6371; // km
                  const dLat = toRad(lat2 - lat1);
                  const dLon = toRad(lon2 - lon1);
                  const a =
                    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
                      Math.sin(dLon / 2) * Math.sin(dLon / 2);
                  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                  return R * c;
                };

                const maxKm = appliedFilters.distance ? Number(appliedFilters.distance) : null;

                const enriched = data.map((item) => {
                  // Try different possible shapes for coordinates
                  let lat = item?.latitude;
                  let lon = item?.longitude;
                  const coords = item?.location?.coordinates; // GeoJSON [lon, lat]
                  if ((lat == null || lon == null) && Array.isArray(coords) && coords.length >= 2) {
                    lon = Number(coords[0]);
                    lat = Number(coords[1]);
                  }
                  const distanceKm = (userLocation?.latitude != null && userLocation?.longitude != null)
                    ? haversineKm(userLocation.latitude, userLocation.longitude, Number(lat), Number(lon))
                    : null;
                  return { ...item, __distanceKm: distanceKm };
                });

                const filteredByDistance = maxKm != null
                  ? enriched.filter((it) => it.__distanceKm != null && it.__distanceKm <= maxKm)
                  : enriched;

                if (!filteredByDistance.length) {
                  return (
                    <div className="col-span-full flex items-center justify-center py-16" key="distance-empty">
                      <div className="max-w-xl w-full bg-white border border-dashed border-[#D9D9D9] rounded-[12px] px-6 py-10 text-center shadow-sm">
                        <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-[#EEF7EF] text-[#4CAF50] mb-6">
                          <CiSearch size={28} />
                        </div>
                        <h3 className="text-xl font-semibold text-[#18181B] mb-3">
                          {t("restaurant").search.noResults}
                        </h3>
                        <p className="text-sm md:text-base text-[#6B7280] leading-6">
                          {t("home").searchFilter.noResultsDescription}
                        </p>
                        <div className="mt-6 flex flex-wrap gap-3 justify-center">
                          <button
                            type="button"
                            onClick={handleClearFilters}
                            className="inline-flex items-center gap-2 px-4 py-2 border border-[#4CAF50] text-[#4CAF50] rounded-full text-sm font-semibold hover:bg-[#EEF7EF] transition-colors"
                          >
                            {t("restaurant").search.clearFilter || "Clear Filters"}
                          </button>
                        </div>
                        <p className="text-xs text-[#94A3B8] mt-4">
                          {t("restaurant").search.adjustFiltersHint || "Try adjusting filters or expanding your search area."}
                        </p>
                      </div>
                    </div>
                  );
                }

                return filteredByDistance.map((item) => {
                  const distanceLabel = item.__distanceKm != null ? `${item.__distanceKm.toFixed(1)}` : null;
                  return (
                    <div
                      key={item?._id}
                     className="relative rounded-[10px] bg-white border border-[#D9D9D9] cursor-pointer"
                      onClick={() => {
                        navigate(`/restaurantdetail`, {
                          state: { restaurantId: item?._id },
                        });
                      }}
                    >

                      {item?.isSponsored && (
                      <span className="absolute top-2 left-2 bg-[#4CAF50] text-white text-xs px-3 py-1 rounded-full">
                        {t("home").discoverSection.sponsored}
                      </span>
                    )}
                      <div>
                         
                        <img
                          src={`${item?.images?.[0]}`}
                          alt="hotel"
                          className="w-full h-[236px] object-cover rounded-t-[9px]"
                        />
                      </div>
                      <div className="pt-[14px] pb-[23px] pr-[17px] pl-[10px]">
                        <h2 className="text-lg font-semibold leading-[30px] mb-[5px] text-[#18181B]">
                          {item?.name}
                        </h2>
                        <div className="flex items-center gap-[10px] justify-between flex-wrap">
                          <span className="text-base leading-[26px] text-[#18181B]">
                            {item?.address}
                          </span>
                          <div className="flex items-center justify-end">
                            {Array(Math.floor(item?.rating))
                              .fill()
                              .map((_, index) => (
                                <MdStar
                                  key={`full-${index}`}
                                  size={21}
                                  className="text-[#FF9D00]"
                                />
                              ))}

                            {item?.rating % 1 !== 0 && (
                              <MdStarHalf size={21} className="text-[#FF9D00]" />
                            )}

                            {Array(5 - Math.ceil(item?.rating))
                              .fill()
                              .map((_, index) => (
                                <MdStarOutline
                                  key={`empty-${index}`}
                                  size={21}
                                  className="text-[#FF9D00]"
                                />
                              ))}
                          </div>
                        </div>
                        <div className="flex gap-[10px] items-center mt-[11px]">
                          <RiHotelLine size={24} className="text-[#7B7B7B]" />
                          <span className="text-[15px] leading-[30px] text-[#18181B]">
                            {t("restaurant").search.ratingsLabel}
                          </span>
                        </div>
                        <p className="text-[15px] text-[#4CAF50] semibold mt-[10px]">
                          {distanceLabel ? `${distanceLabel} ${t("home").searchFilter.distanceText}` : null}
                        </p>
                      </div>
                    </div>
                  );
                });
              })()
            ) : (
              <div className="col-span-full flex items-center justify-center py-16">
                <div className="max-w-xl w-full bg-white border border-dashed border-[#D9D9D9] rounded-[12px] px-6 py-10 text-center shadow-sm">
                  <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-[#EEF7EF] text-[#4CAF50] mb-6">
                    <CiSearch size={28} />
                  </div>
                  <h3 className="text-xl font-semibold text-[#18181B] mb-3">
                    {t("restaurant").search.noResults}
                  </h3>
                  <p className="text-sm md:text-base text-[#6B7280] leading-6">
                    {t("home").searchFilter.noResultsDescription}
                  </p>
                  <div className="mt-6 flex flex-wrap gap-3 justify-center">
                    <button
                      type="button"
                      onClick={handleClearFilters}
                      className="inline-flex items-center gap-2 px-4 py-2 border border-[#4CAF50] text-[#4CAF50] rounded-full text-sm font-semibold hover:bg-[#EEF7EF] transition-colors"
                    >
                      {t("restaurant").search.clearFilter || "Clear Filters"}
                    </button>
                  </div>
                  <p className="text-xs text-[#94A3B8] mt-4">
                    {t("restaurant").search.adjustFiltersHint || "Try adjusting filters or expanding your search area."}
                  </p>
                </div>
              </div>
            )}
          </div>}
          
          
          {/* pagination */}
          {pagination?.pages > 1 && (
            <UserPagination
              currentPage={page}
              setCurrentPage={setPage}
              totalPages={pagination.pages}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default RestaurantOrdering;
